import { render, staticRenderFns } from "./profile-avatar.vue?vue&type=template&id=461c41c4&scoped=true&"
import script from "./profile-avatar.vue?vue&type=script&lang=js&"
export * from "./profile-avatar.vue?vue&type=script&lang=js&"
import style0 from "./profile-avatar.vue?vue&type=style&index=0&id=461c41c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461c41c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
